import {
  LineOfCreditUpdateAutoPayInput,
  LineOfCreditUpdateAutoPayResult,
  Mutation,
} from '@varo/graphql-schema-types';
import SubmitLineOfCreditAutoPayStatus from 'services/graphql/queries/SubmitLineOfCreditAutoPayStatus';
import { getUuid } from 'shared/utils/getUuid/getUuid';
import { CombinedError, useMutation } from 'urql';

interface LineOfCreditAutoPayStatusResult {
  result?: LineOfCreditUpdateAutoPayResult;
  error?: CombinedError;
  fetching: boolean;
  triggerMutation: (input: LineOfCreditUpdateAutoPayInput) => void;
}

const useSubmitLineOfCreditAutoPayStatus =
  (): LineOfCreditAutoPayStatusResult => {
    const [{ data, fetching, error }, executeMutation] = useMutation<Mutation>(
      SubmitLineOfCreditAutoPayStatus,
    );

    const triggerMutation = (input: LineOfCreditUpdateAutoPayInput) => {
      void executeMutation({
        idempotencyId: getUuid(),
        input,
      });
    };

    return {
      result: data?.submitAutoPayForLineOfCredit,
      fetching,
      error,
      triggerMutation,
    };
  };

export default useSubmitLineOfCreditAutoPayStatus;
